/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';
import Reflux from 'reflux';
import {
  Row,
  Modal,
  Button,
  message,
} from 'antd';
import {
  hashHistory,
  withRouter,
} from 'react-router';
import {
  DmsTab,
  TableView,
  AdvanceFormNew,
} from 'Components';
import {
  listQuotation,
  batchDelete,
} from '../../service/quotation';
import {
  config,
  showSpin,
  hideSpin,
} from 'Utils';
import {
  Store,
  Actions,
} from './store';

const confirm = Modal.confirm;

class InfoList extends Reflux.Component {
  constructor(props) {
    super(props);
    const currentChannel = window.sessionStorage.getItem('cur_channel') || '';
    this.channelCode = currentChannel.split('|')[1] || '';
    this.store = Reflux.initStore(Store); //创建一个Store实例
    this.state = {
      groupOptions: [], // 商品分组
      seriesOptions: [], // 商品系列
      productCategoryTree: [], // 商品分类
      filterBoxVisible: false,
      customerList: [],
      selectedRowKeys: [],
      rows: [],
      total: 0,
      searchObj: {
        'p': 1, // 页码
        's': 10, // 条数
        'offerCode': '', // 报价单号
        'customerName': '', // 客户名称
        'specValue': '', // 规格型号
        'productCode': '', // 物料编码
        'startDate': '', // 开始日期
        'endDate': '', // 结束日期
      },
    };
    this.getData = this.getData.bind(this);
    this.pageChange = this.pageChange.bind(this);
    this.visibleChange = this.visibleChange.bind(this);
    this.setFilterParam = this.setFilterParam.bind(this);
    this.advanceReset = this.advanceReset.bind(this);
    this.advanceSubmit = this.advanceSubmit.bind(this);
    this.routeLeaveHook = this.routeLeaveHook.bind(this);
  }

  routeLeaveHook(nextLocation) {
    let path = nextLocation.pathname;
    if (/^\/quotation\/add\/\d+$/.test(path)) { //当下一个路由是详情页时，将useStore的值设为true
      Actions.useStoreChange(true);
      Actions.paramChange({ ...this.state.searchObj });
    } else {
      Actions.useStoreChange(false);
    }
  }

  componentWillMount() { //准备数据
    const data = this.store.state;
    if (data.useStore) { //根据useStore的值判断是否使用store中的数据
      this.setState({
        ...this.state,
        searchObj: {
          ...this.state.searchObj,
          ...data.params,
        },
      });
    }
  }

  componentDidMount() {
    this.mounted = true;
    this.getData();
    //设置离开当前路由时的钩子函数
    this.props.router.setRouteLeaveHook(this.props.route, this.routeLeaveHook);
  }

  getData() {
    const self = this;
    const { searchObj } = this.state;
    listQuotation(searchObj).then(res => {
      if (res.status) {
        self.setState({ total: res.total, rows: res.data });
      } else {
        console.error(res.message);
      }
    });
  }

  goView(url) {
    hashHistory.push(url);
  }

  visibleChange() {
    this.setState({ filterBoxVisible: !this.state.filterBoxVisible });
  }

  advanceReset() {
    const self = this;
    this.setState({
        filterBoxVisible: false,
        searchObj: {
          ...this.state.searchObj,
          'offerCode': '', // 报价单号
          'customerName': '', // 客户名称
          'specValue': '', // 规格型号
          'productCode': '', // 物料编码
          'startDate': '', // 开始日期
          'endDate': '', // 结束日期
          'p': 1, // 页码
        },
      },
      function () {
        self.getData();
      });
  };

  advanceSubmit(form) {
    const self = this;
    this.setState({ filterBoxVisible: false, searchObj: { ...this.state.searchObj, p: 1 } }, function () {
      self.getData();
    });
  };

  setFilterParam(name, value) {
    // console.log(name + ':\t' + value);
    if (name === 'Date') {
      this.setState({
        searchObj: {
          ...this.state.searchObj,
          timeStart: value.from,
          timeEnd: value.end,
        },
      });
    } else {
      this.setState({ searchObj: { ...this.state.searchObj, [name]: value } });
    }
  };

  pageChange(page, pageSize) {
    const self = this;
    this.setState({ searchObj: { ...this.state.searchObj, s: pageSize, p: page } }, function () {
      self.getData();
    });
  }
  deleteHandle () {
    const self = this;
    const { selectedRowKeys } = this.state;
    if(!selectedRowKeys.length) {
      message.warn('请选择要删除的报价单');
      return;
    }
    confirm({
      title: '确定要删除这些报价单?',
      // content: 'When clicked the OK button, this dialog will be closed after 1 second',
      onOk() {
        showSpin();
        batchDelete({ids: selectedRowKeys}).then(res => {
          hideSpin();
          message[res.status ? 'success' : 'error'](res.message);
          res.status && self.getData();
        });
      },
      onCancel() {},
    });
  }
  render() {
    const {
      rows, total, searchObj, selectedRowKeys
    } = this.state;
    const advanceProps = {
      fileds: [
        {
          name: 'offerCode',
          label: '报价单号',
          text: '输入报价单号',
          type: 'default',
          defaultValue: searchObj.offerCode,
        },
        {
          name: 'customerName',
          label: '客户名称',
          text: '输入客户名称',
          type: 'default',
          defaultValue: searchObj.customerName,
        },
        {
          name: 'productCode',
          label: '物料编码',
          text: '输入物料编码',
          type: 'default',
          defaultValue: searchObj.productCode,
        },
        {
          name: 'specValue',
          label: '规格型号',
          text: '输入规格型号',
          type: 'default',
          defaultValue: searchObj.specValue,
        },
        {
          name: 'Date',
          label: '价格起始日期',
          options: [
            { text: '开始时间' },
            { text: '结束时间' },
          ],
          type: 'dateComp',
          defaultValue: {
            from: searchObj.startDate || '',
            end: searchObj.endDate || '',
          },
        },
      ],
      handle: this.advanceSubmit,
      reset: this.advanceReset,
      fieldHandle: this.setFilterParam,
    };
    const tableViewProps = {
      loading: false,
      rowKey: 'id',
      pageParam: {
        total,
        current: searchObj.p,//当前页码
        pageSize: searchObj.s,//当前分页数
        onChange: this.pageChange,
      },
      rowSelection: {
        selectedRowKeys: selectedRowKeys,
        onChange: (selectedRowKeys, selectedRows) => this.setState({ selectedRowKeys }),
      },
      // 报价单号
      // 客户名称
      // 产品数量
      columns: [
        {
          title: '报价单号',
          dataIndex: 'offerCode',
          render: (text, record, index) => <a href={`#/quotation/${record.id}`}>{text}</a>,
        },
        {
          title: '客户名称',
          dataIndex: 'customerName',
        },
        {
          title: '产品数量',
          dataIndex: 'count',
        },
        {
          title: '报价单总金额',
          dataIndex: 'amount',
        },
        {
          title: '优惠金额',
          dataIndex: 'downAmount',
        },
        {
          title: '整单折扣',
          dataIndex: 'discountAmount',
        },
        {
          title: '实际金额',
          dataIndex: 'realityAmount',
        },
        {
          title: '创建时间',
          dataIndex: 'createdDate',
        },
        {
          title: '报价人',
          dataIndex: 'createdName',
        },
        {
          title: '备注',
          dataIndex: 'remark',
        },
        {
          title: '操作',
          dataIndex: 'id',
          render: (text, record, index) => <a href={`${config.server}/api/v1/dms/offer/downWord?id=${record.id}`} target="_blank">下载</a>,
        },
      ],
      rows,
    };
    return <div className="dms-body">
      <DmsTab options={['报价单管理']} defaultKey={0} />
      <div className="advanceForm-box">
        <div className="advanceForm-content">
          <AdvanceFormNew {...advanceProps} />
        </div>
      </div>
      <div className="dms-table-box">
        <Row className="mb-12" type="flex" justify="end" align="middle">
          <Button onClick={this.goView.bind(this, `/quotation/add/0`)}>新建</Button>
          &emsp;
          <Button onClick={this.deleteHandle.bind(this)}>删除</Button>
        </Row>
        <TableView {...tableViewProps} />
      </div>
    </div>;
  }
}

export default withRouter(InfoList);



// WEBPACK FOOTER //
// ./src/routes/quotation/list.js